import { defineStore } from 'pinia'
import { api } from '@/service/api'
import type { CheckEmailResponse } from '@/interface/gen/request'
import type { BaseResponse } from '@/interface/gen/types'

export const useAuthStore = defineStore('authStore', () => {
  async function authStepFirst(email: string): Promise<CheckEmailResponse> {
    return await api.post('/api/public/v1/auth/check-email', {
      email,
    })
  }
  async function authStepSecond(email: string, password: string): Promise<CheckEmailResponse> {
    return await api.post('/api/public/v1/auth/check-credentials', {
      email,
      password
    })
  }

  async function resetPassword(email: string): Promise<BaseResponse> {
    return await api.post('/api/public/v1/auth/reset-password', {
      email,
    })
  }

  async function sudo(userId: number): Promise<BaseResponse> {
    return await api.post('/api/private/v1/auth/sudo', {
      userId,
    })
  }

  async function sudoLogout(): Promise<BaseResponse> {
    return await api.post('/api/private/v1/auth/sudo-logout')
  }


  return {
    authStepFirst,
    authStepSecond,
    resetPassword,
    sudo,
    sudoLogout,
  }
})
